export default __webpack_public_path__ + "static/media/flags.f8428f83.png";